module.exports = __webpack_public_path__ + "UniversityOfVirginia_white400x75-952edb3cdb3ff504f0b6ca89dc02e67f.png";